import {
  format,
  differenceInHours,
  differenceInMinutes,
  isThisYear,
} from 'date-fns';
import sv from 'date-fns/locale/sv';

export const formatDate = (date, dateFormat) =>
  format(date, dateFormat || 'dd MMMM yyyy', {
    locale: sv,
  }).replace(/^0/, '');

export const formatPublishDate = (publishDate, options) => {
  const date = new Date(publishDate);
  const today = new Date();
  const dateInHours = Math.abs(differenceInHours(date, today));
  const dateInMinutes = Math.abs(differenceInMinutes(date, today));
  let format = isThisYear(date) ? 'dd MMMM' : 'dd MMMM yyyy';

  if (options?.shrinkMonths) {
    format = format.replace('MMMM', 'MMM');
  }
  const dateText =
    dateInHours > 12
      ? formatDate(date, format)
      : dateInHours
      ? dateInHours + `${options?.shrinkTime ? ' tim' : ' timmar sedan'}`
      : dateInMinutes
      ? dateInMinutes + `${options?.shrinkTime ? ' min' : ' minuter sedan'}`
      : 'nu';

  return dateText;
};
